// social-link-item.component.ts
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { WebsiteSocialLink } from '../../../../portal.model';

const DEFAULT_MAX_URL_LENGTH = 50;

@Component({
  selector: 'app-social-link-item',
  templateUrl: './social-link-item.component.html',
  styleUrls: ['./social-link-item.component.css'],
})
export class SocialLinkItemComponent {
  @Input() link!: WebsiteSocialLink;
  @Input() disabled = false;

  @Output() edit = new EventEmitter<WebsiteSocialLink>();
  @Output() delete = new EventEmitter<string | number>();

  isHovered = false;

  get platformIcon(): string {
    return `assets/images/social/colored/${this.link.platform}.svg`;
  }

  get platformLabel(): string {
    return this.formatPlatformName(this.link.platform);
  }

  get truncatedUrl(): string {
    return this.truncateUrl(this.link.url);
  }

  onEdit(): void {
    if (this.disabled) return;
    this.edit.emit(this.link);
  }

  onDelete(): void {
    if (this.disabled) return;
    this.delete.emit(this.link.id);
  }

  private formatPlatformName(platform: string): string {
    return platform.charAt(0).toUpperCase() + platform.slice(1).toLowerCase();
  }

  private truncateUrl(
    url: string,
    maxLength: number = DEFAULT_MAX_URL_LENGTH
  ): string {
    if (url.length <= maxLength) return url;

    const withoutProtocol = url.replace(/^https?:\/\/(www\.)?/, '');

    if (withoutProtocol.length <= maxLength) return withoutProtocol;

    return withoutProtocol.substring(0, maxLength - 3) + '...';
  }
}